var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 62,
    viewBox: "0 0 75 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.9385 31.4C46.123 29 42.5134 23.8 42.5134 16.4C42.5134 6.60001 49.5322 1.03633e-06 58.5563 1.03633e-06C68.1819 1.03633e-06 75 6.80001 75 16.4C75 21 74.1979 24.4 70.5882 33.6L59.96 62H43.9172L51.9385 31.4ZM9.42519 31.4C3.60968 29 3.01153e-06 23.8 3.01153e-06 16.4C3.01153e-06 6.60001 7.01871 1.03633e-06 16.0428 1.03633e-06C25.6684 1.03633e-06 32.4866 6.80001 32.4866 16.4C32.4866 21 31.6845 24.4 28.0749 33.6L17.4465 62H1.40374L9.42519 31.4Z",
    fill: "url(#paint0_linear_1239_890)",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1239_890",
    x1: 2.06706,
    y1: 59.0653,
    x2: 75.3126,
    y2: 56.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BD982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345730"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/“.c838bb714825c872cacc537708f52fec.svg";
export { ForwardRef as ReactComponent };